
import { bl_fi_sale_commission_cycle_RowClass } from '../../dbschema/bl_fi_sale_commission_cycle.model';
import { BaseContainerModel } from '../base-container.model';

export class SalesCommissionCycleContainerModel extends BaseContainerModel {
    bl_fi_sale_commission_cycle: bl_fi_sale_commission_cycle_RowClass = new bl_fi_sale_commission_cycle_RowClass();
}
